import React from 'react';

function outcomeBadge(outcome) {
    if (outcome === 'CORRECT')   return <span className='badge bg-success py-1'>Acertou</span>;
    if (outcome === 'INCORRECT') return <span className='badge bg-danger py-1'>Errou</span>;
    return <span className='badge bg-secondary py-1'>Neutro</span>;
}

function signalBadge(signal) {
    if (signal === 'BUY')  return <span className='badge bg-success py-1'>COMPRA</span>;
    if (signal === 'SELL') return <span className='badge bg-danger py-1'>VENDA</span>;
    return <span className='badge bg-secondary py-1'>NEUTRO</span>;
}

function accuracyBadge(acc) {
    if (acc === null || acc === undefined) return <span className='text-muted'>—</span>;
    const cls = acc >= 60 ? 'bg-success' : acc >= 45 ? 'bg-warning text-dark' : 'bg-danger';
    return <span className={`badge py-1 ${cls}`}>{acc.toFixed(1)}%</span>;
}

/**
 * props:
 * - data: { total, correct, incorrect, neutral, accuracy, bySymbol, recent }
 */
function AiSignalStats({ data }) {
    if (!data || data.total === 0) return null;

    const { total, correct, incorrect, neutral, accuracy, bySymbol, recent } = data;

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <h6 className='mb-3'>Resumo dos Sinais da IA</h6>

            {/* Summary badges */}
            <div className='d-flex gap-3 mb-4 flex-wrap'>
                <div className='text-center'>
                    <div className='fs-4 fw-bold'>{total}</div>
                    <small className='text-muted'>Avaliados</small>
                </div>
                <div className='text-center'>
                    <div className='fs-4 fw-bold text-success'>{correct}</div>
                    <small className='text-muted'>Corretos</small>
                </div>
                <div className='text-center'>
                    <div className='fs-4 fw-bold text-danger'>{incorrect}</div>
                    <small className='text-muted'>Incorretos</small>
                </div>
                <div className='text-center'>
                    <div className='fs-4 fw-bold text-secondary'>{neutral}</div>
                    <small className='text-muted'>Neutros</small>
                </div>
                <div className='text-center ms-auto'>
                    <div className='mb-1'>Precisão Geral</div>
                    {accuracyBadge(accuracy)}
                </div>
            </div>

            <div className='row'>
                {/* By Symbol */}
                {bySymbol && bySymbol.length > 0 && (
                    <div className='col-md-4 mb-3'>
                        <h6 className='text-muted small mb-2'>POR SÍMBOLO</h6>
                        <table className='table table-sm mb-0'>
                            <thead>
                                <tr>
                                    <th>Símbolo</th>
                                    <th className='text-center'>Sinais</th>
                                    <th className='text-center'>Precisão</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bySymbol.map(row => (
                                    <tr key={row.symbol}>
                                        <td><strong>{row.symbol}</strong></td>
                                        <td className='text-center'>{row.total}</td>
                                        <td className='text-center'>{accuracyBadge(row.accuracy)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Recent signals */}
                {recent && recent.length > 0 && (
                    <div className='col-md-8 mb-3'>
                        <h6 className='text-muted small mb-2'>SINAIS RECENTES</h6>
                        <table className='table table-sm mb-0'>
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Símbolo</th>
                                    <th className='text-center'>Sinal</th>
                                    <th className='text-center'>Confiança</th>
                                    <th className='text-center'>Resultado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recent.map((s, i) => (
                                    <tr key={i}>
                                        <td className='text-muted small'>
                                            {new Date(s.createdAt).toLocaleDateString()}
                                        </td>
                                        <td><strong>{s.symbol}</strong></td>
                                        <td className='text-center'>{signalBadge(s.signal)}</td>
                                        <td className='text-center'>
                                            {s.confidence != null
                                                ? `${(s.confidence * 100).toFixed(0)}%`
                                                : '—'}
                                        </td>
                                        <td className='text-center'>{outcomeBadge(s.outcome)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AiSignalStats;
